/* eslint-disable no-use-before-define */
import {css} from '@emotion/core'
import {mediaQueries} from '../twd'
export const sectionCss = css`
    background-color: #ffffff;
    ${mediaQueries.notXs} {
        padding: 0 20px;
    }
`
export const tableCss = css`
    tbody tr td {
        vertical-align:top;
    }
    tbody tr td:nth-child(1) {
        color: #767676;
    }
    tbody tr td:nth-child(2) {
        text-align:right;
    }
    tbody tr td:nth-child(3) {
        text-align:right;
    }
`

export const headerCss = css`
    tbody tr td {
        vertical-align:top;
    }
    tbody tr td:nth-child(2) {
        text-align:right;
        font-weight: 500;
    }
`


export const listCss = css `
    div {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    dt, dd {
        padding: 6px;
        line-height: 1.4;
        font-weight:400;
        color: #242424;
        border-bottom: 1px solid #e4e4e4;
    }
    dt {
        text-align: left;
    }
    dd {
        text-align: right;
        font-weight: 500;
    }
`


export const sectionListCss = css `
    & {
        display:grid;
        grid-template-columns: 1fr 1fr;
    }
    dt, dd {
        padding: 6px;
        line-height: 1.4;
        font-weight:400;
        border-bottom: 1px solid #e4e4e4;
    }
    dt {
        text-align: left;
        color: #767676;
    }
    dd {
        text-align: right;
        color: #242424;
    }
`
